import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

import EmailEntry from './EmailEntry/EmailEntry';

import EmailThreadViewerLayout from '../../../../components/EntryPanel/EmailThreadEntryViewer/components/EmailThreadViewer/EmailThreadViewerLayout/EmailThreadViewerLayout';
import InfoPanel from '../../../../components/EntryPanel/EmailThreadEntryViewer/components/EmailThreadViewer/InfoPanel/InfoPanel';
import SidebarActions from '../../../../components/EntryPanel/EmailThreadEntryViewer/components/EmailThreadViewer/SidebarActions/SidebarActions';
import { useEmailThreadEntryViewer } from '../../../../components/EntryPanel/EmailThreadEntryViewer/store/emailThreadEntryViewer.store';
import { EmailEntry as EmailEntryType, EmailFileEntry } from '../../../../types';
import FileEntryViewer from '../FileEntryViewer/FileEntryViewer';

const defaultSidebarSettings = {
  isDeleteEnabled: true,
};

type EmailEntryViewerProps = {
  emailEntry: EmailEntryType;
  projectId: string;
  preselectedFileId: number;
};

const EmailEntryViewer = ({
  emailEntry,
  projectId,
  preselectedFileId,
}: EmailEntryViewerProps) => {
  const [emailFileEntry, setEmailFileEntry] = useState(null);
  const { setSelectedEmailEntry, showSidePanel } = useEmailThreadEntryViewer();

  useEffect(() => {
    setSelectedEmailEntry(emailEntry);

    if (!preselectedFileId) {
      return;
    }

    const preselectedFile = emailEntry.files.list.find((f) => f.file.id === preselectedFileId);
    if (preselectedFile) {
      setEmailFileEntry(preselectedFile);
    }
  }, []);

  return (
    <div
      className={clsx(
        'container--selectedEntryViewer',
        'tw-relative',
        'tw-w-full tw-grow',
        'tw-max-h-[calc(100vh-110px)] tw-scroll-styles',
        emailFileEntry ? 'tw-overflow-hidden' : 'tw-overflow-y-auto'
      )}
    >
      <EmailThreadViewerLayout>
        <div
          className={clsx(
            'container--selectedEntryViewer',
            'tw-relative',
            'tw-w-full tw-grow',
            ' tw-scroll-styles',
            !emailFileEntry && 'tw-overflow-y-auto tw-min-h-[calc(100vh-105px)]'
          )}
        >
          <EmailEntry
            key={`ee_${emailEntry.id}`}
            emailEntry={emailEntry}
            onSetEmailFileEntry={setEmailFileEntry}
          />

          {emailFileEntry && (
            <FileEntryViewer
              emailFileEntry={emailFileEntry}
              allFiles={emailEntry.files.list as EmailFileEntry[]}
              onSetEmailFileEntry={setEmailFileEntry}
              totalCount={emailEntry.files.total}
              inboxEntryId={emailEntry.inboxEntryId}
              emailId={emailEntry.id}
              projectId={projectId}
            />
          )}
        </div>
        {showSidePanel && !emailFileEntry && (
          <div
            className={clsx(
              'container--selectedEntryDetails',
              'tw-rounded-[5px] tw-border-[1px] tw-border-solid tw-border-cfo-grey-500',
              'tw-max-w-[400px] tw-w-full tw-grow',
              'tw-ml-[5px]'
            )}
          >
            <InfoPanel />
          </div>
        )}
        {!emailFileEntry && <SidebarActions sidebarSettings={defaultSidebarSettings} />}
      </EmailThreadViewerLayout>
    </div>
  );
};

export default EmailEntryViewer;
